import React from 'react';
import { styled } from '@compiled/react';
import { InterpolatedFormattedMessage } from '@atlassian/jira-onboarding-core';
import {
	useNudgeStep,
	useHasNudgeActive,
	DEFAULT_NUDGE_WIDTH,
} from '@atlassian/jira-onboarding-quickstart-core';
// eslint-disable-next-line jira/restricted/instrumented-spotlight-card
import { InstrumentedNudgeSpotlightCard } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/instrumented-nudge-spotlight-card';
import type { QuickstartNudgeWrapperProps } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/quickstart-nudge/types';
import { BoldWrapper } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/simple-wrappers';
import messages from './messages';

export const NavigationProfileNavItemWrapperNudge = ({
	children,
	nudgeId,
}: QuickstartNudgeWrapperProps) => {
	const [nudgeStep, { setNudgeStep }] = useNudgeStep();
	const [hasNudgeActive, { setHasNudgeActive }] = useHasNudgeActive();

	const hideNudge = () => {
		setNudgeStep('');
		setHasNudgeActive(false);
	};

	return (
		<InstrumentedNudgeSpotlightCard
			nudgeId={nudgeId}
			content={
				<div>
					<InterpolatedFormattedMessage
						messageDescriptor={messages.content}
						messageMappings={{
							tag: BoldWrapper,
						}}
					/>
				</div>
			}
			width={DEFAULT_NUDGE_WIDTH}
			hidden={nudgeStep !== nudgeId || hasNudgeActive === false}
			setHidden={hideNudge}
			onOutsideClick={hideNudge}
		>
			<ChildrenWrapper>{children}</ChildrenWrapper>
		</InstrumentedNudgeSpotlightCard>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChildrenWrapper = styled.div({
	'::before, ::after': {
		borderRadius: '50%',
		width: '36px',

		left: '50%',
		transform: 'translateX(-50%)',
	},
});
